import React, { createContext, useState, useEffect, useContext } from "react";
import useConfig from "../config/useConfig";

const ThemeContext = createContext();

const getSystemTheme = () => {
  if (typeof window !== "undefined" && window.matchMedia) {
    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  }
  return "light";
};

export const ThemeProvider = ({ children }) => {
  const config = useConfig();

  // Try localStorage → fallback to system theme
  const storedTheme =
    (typeof window !== "undefined" && localStorage.getItem("themeType")) ||
    getSystemTheme();

  const [themeName, setThemeName] = useState("light");

  const themes = {
    light: {
      background: "#ffffff",
      card: "#f9f9f9",
      primary: config?.THEME_COLOR, // 👈 from config
      text: "#000000",
      textSecondary: "#555555",
      accent: "#4CAF50",
      border: "#dddddd",
      mode: "light",
      buy: "#4CAF50",
      sell: "#F44336",
      buymeta: "#007AFF",
      sellsell: "#D32F2F",
      white: "#ffffff",
      black: "#000000",
      shadowColor: "#000",
    },
    dark: {
      background: "#000000",
      card: "#1a1a1a",
      primary: config?.THEME_COLOR, // 👈 from config
      text: "#ffffff",
      textSecondary: "#aaaaaa",
      accent: "#4CAF50",
      border: "#2c2c2c",
      mode: "dark",
      buy: "#4CAF50",
      sell: "#F44336",
      buymeta: "#007AFF",
      sellsell: "#D32F2F",
      white: "#ffffff",
      black: "#000000",
      shadowColor: "#000",
    },
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Save preference
      localStorage.setItem("theme", themeName);

      // Apply class to <html>
      document.documentElement.className = themeName;

      // Inject CSS variables for easier styling
      const currentTheme = themes[themeName];
      Object.entries(currentTheme).forEach(([key, value]) => {
        document.documentElement.style.setProperty(`--${key}`, value);
      });
    }
  }, [themeName, config]); // 👈 re-run when config changes

  const toggleTheme = () => {
    setThemeName((prev) => (prev === "light" ? "dark" : "light"));
  };

  const theme = themes[themeName];

  return (
    <ThemeContext.Provider value={{ theme, themeName, toggleTheme, config }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
